import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { DatePipe } from '@angular/common';
import { v4 as uuidv4 } from 'uuid';

import {
  CreateMassiveDeliveryRequest,
  ListCitiesRequest,
  ListCitiesResponse,
  ListDistributionCenterRequest,
  ListDistributionCenterResponse,
  ListMassiveDeliverCompaniesRequest,
  ListMassiveDeliverCompaniesResponse,
  MassiveDeliveryRequest,
} from '../../../../../shared/api/gen_api_client/routing_pb';
import * as grpcWeb from 'grpc-web';
import {
  CityServiceClient,
  ClientPointServiceClient,
  CompanyServiceClient,
  MassiveDeliveryServiceClient,
} from '../../../../../shared/api/gen_api_client/RoutingServiceClientPb';
import { City, ClientPointCompany, Company, Country, MdDetail, VehicleTypeSelectType } from './parametrizacion.interface';
import { MassiveService } from '../../../../massive.service';
import { MessageService } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { Flags } from 'src/app/components/shared/types/flags.type';
import { MassiveCreateFlags } from '../../massive-create.flags';
import { environment } from 'src/environments/environment';
import { ProcessingData } from 'src/app/components/shared/types/processingData.type';
import { GrpcFactoryService } from 'src/app/components/shared/sharedServices/grpc-factory.service';
import { Router } from '@angular/router';
import { MuException } from 'src/app/components/shared/types/exception.type';
import { MuLayoutService } from 'src/app/components/shared/sharedProtos/layout/mu-layout.service';

@Component({
  selector: 'app-parametrizacion',
  templateUrl: './parametrizacion.component.html',
  styleUrls: ['./parametrizacion.component.sass'],
  providers: [DatePipe, MessageService],
})
export class ParametrizacionComponent implements OnInit, OnChanges, AfterViewInit {
  /**
   * Flags used in the page
   */
  @Input() flags: Flags<MassiveCreateFlags>;
  @Input() countryObject: Country[];
  @Input() selCountry: Country;
  @Output() requestIdService = new EventEmitter();

  /**
   * Flags used in massive create
   */
  massiveCreateFlags = MassiveCreateFlags;
  /**
   * Loading excel info
   */
  processingExcel: ProcessingData<MassiveCreateFlags>;

  fileId: string;
  activeIndex: number;

  selectedCity: City;
  selectedCountry: Country;
  selectedCompany: Company;

  countries: Country[];
  filteredContry: Country[] = [];

  cities: City[] = null;
  filteredCities: City[] = [];

  companies: Company[] = null;
  filteredCompanies: Company[] = [];

  startTime: Date;
  endTime: Date;
  deliveryDate: Date;
  loading = false;

  clientPointsCompany: ClientPointCompany[];
  selectedClientPoint: ClientPointCompany;

  vehicleTypes: VehicleTypeSelectType[];
  selectedVehicleType: VehicleTypeSelectType;

  mdRequests: MassiveDeliveryRequest[] = null;
  mdClient: MassiveDeliveryServiceClient;
  selectedMdRequest: MassiveDeliveryRequest = null;
  mdRequestDetails: MdDetail[] = null;

  addressOverlays: any[];
  map: google.maps.Map;
  addressMap: google.maps.Map;
  showModalCedi = false;
  labelButtonCedi = 'CREAR CEDI';

  /**
   * is the file uploaded
   */
  fileUploaded: boolean;

  constructor(
    private datePipe: DatePipe,
    private grpcFactoryService: GrpcFactoryService,
    private massiveService: MassiveService,
    private messageService: MessageService,
    private router: Router,
    private layoutService: MuLayoutService
  ) {
    this.startTime = new Date();
    this.startTime.setHours(6, 0, 0, 0);
    this.endTime = new Date();
    this.endTime.setHours(18, 0, 0, 0);
    this.deliveryDate = new Date();
    this.deliveryDate.setDate(this.deliveryDate.getDate() + 1);
    this.fileUploaded = false;
    this.getCountry();
  }

  ngAfterViewInit(): void {
    const labelRef = document.getElementById('mu-file-snd-create')?.getElementsByClassName('p-button-label')[0];
    if (labelRef) labelRef.innerHTML = 'Cargar Archivo';
  }

  ngOnInit() {
    this.processingExcel = new ProcessingData<MassiveCreateFlags>({
      flags: this.flags,
      errorFlag: MassiveCreateFlags.PROCESSING_EXCEL_FAIL,
      showFlag: MassiveCreateFlags.PROCESSING_EXCEL_FILE,
      title: 'context.massive.processingExcel.title',
      message: 'context.massive.processingExcel.message',
      errorTitle: 'context.massive.processingExcel.errorTitle',
    });
    this.vehicleTypes = [
      { name: 'MOTO', id: 1, value: 1 },
      { name: 'CAMIÓN', id: 2, value: 2 },
      { name: 'MIXTO', id: 3, value: 3 },
    ];
    this.selectedVehicleType = this.vehicleTypes[0];
    this.fileId = uuidv4();
    this.getDatafromBackend();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.hasOwnProperty('countryObject')) {
      this.countries = changes.countryObject.currentValue;
    }
    if (changes.hasOwnProperty('selCountry')) {
      this.selectedCountry = changes.selCountry.currentValue;
    }
  }

  getDatafromBackend() {
    this.mdClient = this.grpcFactoryService.create(
      MassiveDeliveryServiceClient,
      environment.hostnameMassive,
      'MassiveDeliveryServiceClient'
    );
    this.refreshClients();
    this.loadCities();
  }

  /**
   * Build streaming with a request
   */
  buildStreaming(): any {
    const request = new CreateMassiveDeliveryRequest();
    request.setCompanyid(this.selectedCompany.id);
    request.setCityid(this.selectedCity.id);
    request.setCountry(this.selectedCountry.geoName);
    request.setCedipointid(this.selectedClientPoint.id);
    request.setStarttime(this.getTime(this.startTime));
    request.setEndtime(this.getTime(this.endTime));
    request.setCityname(this.selectedCity.geoName);
    request.setVehicletypeid(this.selectedVehicleType.id);
    request.setVehicletypename(this.selectedVehicleType.name);
    request.setFileid(this.fileId);
    const formattedDate = this.datePipe.transform(this.deliveryDate, 'dd/MM/yyyy');
    request.setStartdate(formattedDate);
    this.massiveService.setTypeVehicleSelected(this.selectedVehicleType);
    return this.mdClient.createMassiveDelivery(request, {});
  }

  /**
   * Load an excel file and create the service's stops
   */
  createMassiveDistribution(): void {
    this.processingExcel.begin();
    const streaming = this.buildStreaming();
    if (typeof streaming?.on !== 'function') {
      return environment.guardClause;
    }
    let requestId = 0;
    streaming.on('data', data => {
      switch (data?.getStatus()) {
        case 'TICK': {
          return environment.guardClause;
        }
        case 'REQUEST': {
          requestId = data?.getRequestid();
          return environment.guardClause;
        }
        case 'END': {
          if (requestId) {
            this.router.navigate(['masivos/services', requestId]);
          }
          this.processingExcel.end();
          return environment.guardClause;
        }
        case 'OK': {
          this.processingExcel.init(data?.getRecordsquantity());
          this.processingExcel.setProgress(data?.getRecordsprocessed());
          return environment.guardClause;
        }
        default: {
          requestId = 0;
          const msg = data?.getMessage();
          if (!msg.includes('{')) {
            this.processingExcel.markError(msg);
            return environment.guardClause;
          }
          const { type, ...payload } = JSON.parse(data?.getMessage());
          this.processingExcel.markError(`context.massive.processingExcel.${type}`, payload);
          return environment.guardClause;
        }
      }
    });
    streaming.on('error', _ => {
      requestId = 0;
      this.processingExcel.markError('context.massive.processingExcel.genericErrorMessage');
    });
  }

  refreshClients() {
    const request = new ListMassiveDeliverCompaniesRequest();
    const client = this.grpcFactoryService.create(CompanyServiceClient, environment.hostnameMassive, 'CompanyServiceClient');
    client.listMassiveDeliverCompanies(request, {}, (err: grpcWeb.Error, response: ListMassiveDeliverCompaniesResponse) => {
      if (err) {
        console.log(err);
      } else {
        this.companies = response?.getCompaniesList()?.map(company => {
          return { id: company.getId(), name: company.getName() };
        });
      }
    });
  }

  setMap(event) {
    this.map = event.map;
  }

  setAddressMap(event) {
    this.addressMap = event.map;
  }

  loadCities() {
    const request = new ListCitiesRequest();
    const client = this.grpcFactoryService.create(CityServiceClient, environment.hostnameMassive, 'CityServiceClient');
    client.listCities(request, {}, (err: grpcWeb.Error, response: ListCitiesResponse) => {
      if (err) {
        console.log(err);
      } else {
        this.cities = response?.getCitiesList()?.map(clienta => {
          return {
            id: clienta.getId(),
            name: clienta.getName(),
            geoName: clienta.getGeoname(),
          };
        });
      }
    });
  }

  filterCities($event) {
    this.filteredCities = [];
    this.cities.forEach(city => {
      if (city.name.toLowerCase().indexOf($event.query.toLowerCase()) === 0) {
        this.filteredCities.push(city);
      }
    });
  }

  filterCompanies($event) {
    this.filteredCompanies = [];
    this.companies.forEach(city => {
      if (city.name.toLowerCase().indexOf($event.query.toLowerCase()) === 0) {
        this.filteredCompanies.push(city);
      }
    });
  }

  cityCediSelected() {
    if (this.selectedCompany) {
      this.updateClientPoints(this.selectedCompany);
    }
  }

  updateClientPoints(company: Company) {
    const request = new ListDistributionCenterRequest();
    request.setCompanyid(company.id);
    const client = this.grpcFactoryService.create(ClientPointServiceClient, environment.hostnameMassive, 'ClientPointServiceClient');
    client.listDistributionCenter(request, {}, (err: grpcWeb.Error, response: ListDistributionCenterResponse) => {
      if (err) {
        console.log(err);
      } else {
        let updatePoint = true;
        this.clientPointsCompany = response
          ?.getClientpointsList()
          ?.map(cp => {
            if (this.selectedCity.id === cp.getIdcity()) {
              if (this.selectedClientPoint && this.selectedClientPoint.id === cp.getId()) {
                updatePoint = false;
              }
              return { id: cp.getId(), name: cp.getName() };
            }
          })
          .filter(res => res !== undefined);
        if (this.clientPointsCompany !== null) {
          if (updatePoint) {
            this.selectedClientPoint = this.clientPointsCompany[0];
          }
        }
      }
    });
  }

  handleModalCedi() {
    this.updateClientPoints(this.selectedCompany);
    this.showModalCedi = !this.showModalCedi;
  }

  showSuccess() {
    this.messageService.add({
      severity: 'success',
      summary: 'CEDI',
      detail: 'Fue creado con éxito!',
    });
  }
  /**
   * called when the file is pending uploaded
   */
  handleFilePending() {
    this.fileUploaded = false;
  }

  /**
   * called to enable the create service button
   */
  get allowCreateService(): boolean {
    return this.selectedClientPoint && this.fileUploaded;
  }

  /**
   * Upload the excel file
   */
  async eventUploadExcelFile(control: FileUpload, $event) {
    try {
      await this.massiveService.uploadExcelFile(this.fileId, $event.files[0]);
      this.fileUploaded = true;
    } catch (e) {
      control.clear();
      throw new MuException(e);
    }
  }

  cancelMassiveDistribution() {
    this.router.navigate(['masivos/request']);
  }

  /**
   * format date
   *
   * @param d
   * @returns
   */
  private getTime(d: Date): string {
    return this.datePipe.transform(d, 'HH:mm');
  }

  /**
   * get country
   */
  async getCountry(): Promise<void> {
    if (!this.selCountry) {
      this.layoutService.currentCountryValue.subscribe(countryVal => {
        const result = environment.countries.filter(item => item.geoName === countryVal);
        this.selectedCountry = result[0];
      });
    }
  }
}
